
// This file provides compatibility for the health API endpoints
// While most health functionality is now handled via WebSocket,
// we still need GET functionality for the login screen

import api from './core';

/**
 * Check API health using GET request (needed for login screen)
 * @returns Promise with health status
 */
export const checkApiHealth = async (signal?: AbortSignal) => {
  try {
    const response = await api.get('/health/', { signal });
    return response.data;
  } catch (error) {
    console.error('Health check error:', error);
    return { status: 'error' };
  }
};

/**
 * Get health status using GET request
 * @returns Promise with health status data
 */
export const getHealthStatus = async (signal?: AbortSignal) => {
  try {
    const response = await api.get('/health/status/', { signal });
    return response.data;
  } catch (error) {
    console.error('Health status error:', error);
    return null;
  }
};
